module.exports = __webpack_public_path__ + "/images/testimonial-2.be3de90.png";